/** Survives full-page redirect so the login screen can show the same copy as the toast. */
export const SESSION_AUTH_TOAST_STORAGE_KEY = 'maktab:lastAuthToast'

/** Query param on `/login` for durable messaging after session-related redirects. */
export const LOGIN_REASON_PARAM = 'reason' as const

export const LoginReason = {
  sessionExpired: 'session_expired',
  authRequired: 'auth_required',
} as const

export type LoginReasonValue = (typeof LoginReason)[keyof typeof LoginReason]

export function loginPathWithReason(reason: LoginReasonValue): string {
  const qs = new URLSearchParams({ [LOGIN_REASON_PARAM]: reason })
  return `/login?${qs.toString()}`
}
